import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1061"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"m14.297 12.181-12.59-.038h-.002a.703.703 0 0 0-.705.698.702.702 0 0 0 .703.702l12.59.038h.002a.703.703 0 0 0 .705-.698.702.702 0 0 0-.703-.702z\"></path><circle cx=\"1.556\" cy=\"4.929\" r=\"1.5\"></circle><circle cx=\"8\" cy=\"4.929\" r=\"1.5\"></circle><circle cx=\"4.531\" cy=\"8.64\" r=\"1.757\"></circle><circle cx=\"11.469\" cy=\"8.64\" r=\"1.757\"></circle><circle cx=\"14.5\" cy=\"4.929\" r=\"1.5\"></circle>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_8))
}
export default { render: render }